import api from './api';

// Mock dashboard data
const mockDashboardData = {
  stats: {
    totalNews: 15,
    totalBlogs: 28,
    totalGalleryImages: 45,
    totalClients: 12,
    totalServices: 8,
    totalReviews: 34
  },
  recentActivity: [
    {
      id: 1,
      type: 'news',
      action: 'created',
      title: 'New Infrastructure Project Launched',
      user: 'Admin',
      timestamp: '2026-02-21T08:30:00Z'
    },
    {
      id: 2,
      type: 'blog',
      action: 'updated',
      title: 'The Future of Sustainable Infrastructure',
      user: 'Admin',
      timestamp: '2026-02-21T07:45:00Z'
    },
    {
      id: 3,
      type: 'review',
      action: 'approved',
      title: 'Review by Rajesh Kumar',
      user: 'Admin',
      timestamp: '2026-02-20T16:20:00Z'
    },
    {
      id: 4,
      type: 'gallery',
      action: 'uploaded',
      title: '5 new images added',
      user: 'Admin',
      timestamp: '2026-02-20T14:10:00Z'
    },
    {
      id: 5,
      type: 'client',
      action: 'created',
      title: 'ABC Construction Ltd added',
      user: 'Admin',
      timestamp: '2026-02-20T11:30:00Z'
    }
  ],
  chartData: {
    visitors: [120, 150, 180, 220, 280, 320, 350],
    pageViews: [450, 520, 610, 750, 890, 980, 1100],
    labels: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
  }
};

export const dashboardService = {
  getStats: async () => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: mockDashboardData.stats });
        }, 500);
      });
    }
    return api.get('/dashboard/stats');
  },

  getRecentActivity: async () => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: mockDashboardData.recentActivity });
        }, 500);
      });
    }
    return api.get('/dashboard/activity');
  },

  getChartData: async () => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: mockDashboardData.chartData });
        }, 500);
      });
    }
    return api.get('/dashboard/charts');
  },

  getAll: async () => {
    if (process.env.NODE_ENV === 'development') {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ data: mockDashboardData });
        }, 500);
      });
    }
    return api.get('/dashboard');
  }
};
